import Chart from 'Modules/dashboard/views/.components/chart/.components/main';
import DevicesByStatus from 'Modules/dashboard/views/.components/chart/.components/devicesByStatus';
import StackedBar from 'Modules/dashboard/views/.components/chart/.components/stackedBar';
const Gadgets = ({ item, update, exportData }) => {
    
    const renderComponent = (view) => {
        let views = {
            'Chart': <Chart key={item.id} item={item} update={update} />,
            'ClipRequestByStatus': <Chart key={item.id} item={item} update={update} />,
            'VidFleetFirmware': <Chart key={item.id} item={item} update={update} />,
            'DevicesByStatus': <DevicesByStatus key={item.id} item={item} update={update} exportData={exportData}/>,
            'UnitsThatStoppedReporting': <Chart key={item.id} item={item} update={update} />,
            'MaintenanceWarnings': <StackedBar key={item.id} item={item} update={update} />,
            'Default': <div>Default</div>,
        };
        return views[view?.type] ||  views['Default']
    }

    return (
        <>
            {renderComponent(item)}
        </>
    )
}

export default Gadgets